module.exports = __webpack_public_path__ + "img/checklist.28381ed5.svg";